module.exports = __webpack_public_path__ + "img/symbol_10.1f041421.png";